import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  ClearLegacyToken: "[Clear Legacy Token] Action",
  SetMfaEnabled: "[SetMfaEnabled] Action",
};

const initialAuthState = {
  me: undefined,
  authToken: undefined,
};

export const reducer = persistReducer(
  { storage, key: "app-auth", whitelist: ["me", "authToken"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        return {
          ...state,
          authToken: action.payload.authToken,
          me: action.payload.user,
        };
      }

      case actionTypes.Logout: {
        routerHelpers.forgotLastLocation();
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        return {
          ...state,
          me: action.payload,
        };
      }

      case actionTypes.ClearLegacyToken: {
        return {
          ...state,
          authToken: undefined,
        };
      }

      case actionTypes.SetMfaEnabled: {
        if (!state.me?.user) return state;
        return {
          ...state,
          me: {
            ...state.me,
            user: {
              ...state.me.user,
              mfaEnabled: action.payload,
            },
          },
        };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: (payload) => ({ type: actionTypes.Login, payload }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: (payload) => ({ type: actionTypes.UserRequested, payload }),
  fulfillUser: (payload) => ({ type: actionTypes.UserLoaded, payload }),
  clearLegacyToken: () => ({ type: actionTypes.ClearLegacyToken }),
  setMfaEnabled: (payload) => ({ type: actionTypes.SetMfaEnabled, payload }),
};

export function* saga() {}
